import { HttpInterceptorFn } from '@angular/common/http';

export const sourceInterceptor: HttpInterceptorFn = (req, next) => {
  const modifiedReq = req.clone({
    setHeaders: {
      'X-Source': 'Portal',
    },
  });

  return next(modifiedReq);
};
